const GRAPHQL_URL = import.meta.env.VITE_GRAPHQL_URL || 'http://localhost:3000/graphql';
const DEBUG = import.meta.env.DEV;

class GraphQLClient {
  constructor(url = GRAPHQL_URL) {
    this.url = url;
  }

  async query(query, variables = {}) {
    try {
      if (DEBUG) {
        console.log('📨 GraphQL Query:', { query: query.substring(0, 50) + '...', variables });
      }

      const response = await fetch(this.url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          query,
          variables,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();

      if (data.errors) {
        const errorMessage = data.errors[0].message || 'GraphQL error';
        throw new Error(errorMessage);
      }

      if (DEBUG) {
        console.log('✓ GraphQL Response:', data.data);
      }

      return data.data;
    } catch (error) {
      console.error('✗ GraphQL Error:', error.message);
      throw error;
    }
  }

  async getSpotsInBounds(bounds, filters = {}) {
    const query = `
      query GetSpotsInBounds($bounds: BoundsInput!, $filters: SpotFilterInput) {
        spotsInBounds(bounds: $bounds, filters: $filters) {
          id
          name
          description
          location {
            coordinates
          }
          depth {
            min
            max
            avg
          }
          fishSpecies
          facilities
          bestSeasons
          difficulty
          accessibility
          spotType
          depthMapImage
          videoUrl
          createdAt
        }
      }
    `;

    const variables = {
      bounds,
      filters: Object.keys(filters).length > 0 ? filters : null,
    };

    const result = await this.query(query, variables);
    return result.spotsInBounds || [];
  }

  async getSpot(id) {
    const query = `
      query GetSpot($id: ID!) {
        spot(id: $id) {
          id
          name
          description
          location {
            coordinates
          }
          depth {
            min
            max
            avg
          }
          fishSpecies
          facilities
          bestSeasons
          difficulty
          accessibility
          spotType
          depthMapImage
          videoUrl
          createdAt
          updatedAt
        }
      }
    `;

    const result = await this.query(query, { id });
    return result.spot;
  }

  subscribe(subscription, onData, onError) {
    if (DEBUG) {
      console.log('📡 Setting up GraphQL subscription');
    }

    // WebSocket subscriptions would be implemented here
    // For now, this is a placeholder for Phase 5
    console.warn('Subscriptions not yet implemented');
  }
}

export const graphqlClient = new GraphQLClient();
